// extracted by mini-css-extract-plugin
export default {"SideBarComponent":"sideBar_SideBarComponent__Aj5lA","SideBarContent":"sideBar_SideBarContent__KuOtv","Open":"sideBar_Open__Phl5I"};